import StorageService, { STORAGE_KEYS } from './storage.util';

interface DecodedToken {
  given_name?: string;
  family_name?: string;
  email?: string;
  sub?: string;
  [key: string]: any;
}

export const decodeIdToken = (): DecodedToken | null => {
  const idToken = StorageService.getItem(STORAGE_KEYS.ID_TOKEN);
  if (!idToken) return null;
  
  try {
    const base64Url = idToken.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const padding = '='.repeat((4 - base64.length % 4) % 4);
    
    return JSON.parse(atob(base64 + padding));
  } catch (error) {
    console.error('Failed to decode ID token:', error);
    return null;
  }
};

export const decodeMetadataToken = () => {
  const metadataToken = StorageService.getItem(STORAGE_KEYS.METADATA_TOKEN);
  if (!metadataToken) return null;
  
  try {
    const base64Url = metadataToken.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const padding = '='.repeat((4 - base64.length % 4) % 4);
    
    return JSON.parse(atob(base64 + padding));
  } catch (error) {
    console.error('Failed to decode metadata token:', error);
    return null;
  }
};

export const decodeAccessToken = () => {
  const token = StorageService.getItem(STORAGE_KEYS.ACCESS_TOKEN);
  if (!token) return null;
  
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const padding = '='.repeat((4 - base64.length % 4) % 4);
    
    return JSON.parse(atob(base64 + padding));
  } catch (error) {
    console.error('Failed to decode metadata token:', error);
    return null;
  }
};
